<pxc-loader *transloco="let t" data-testid="loading">
  {{ t('Chargement des photos...') }}
</pxc-loader>
